<template>
    <div name="tab" class="tabs">
        <div v-for="(title, index) in list" :class="index === selected ? 'active' : 'inactive'" :key="index"
            @click="index !== selected ? select(index) : null"
        >
            {{ title }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'tab',
    props: ['list', 'selectedIndex'],
    data: function()
    {
        return {
            selected: 0
        }
    },
    mounted: function()
    {
        this.selected = this.selectedIndex;
    },
    methods: {
        select: function(index)
        {
            this.selected = index;
            this.$emit('select', this.selected);
        }
    }
}
</script>

<style scoped>
    .tabs {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        border-bottom: 1px solid #EDEEF0;
        padding-top: 8.5px;
        box-sizing: border-box;
    }
    .active {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-right: 16px;
        border-bottom: 1.5px solid #1E1E1E;
        padding-bottom: 6px;
    }
    .inactive {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-right: 16px;
        cursor: pointer;
        padding-bottom: 6px;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/Tab.vue